import React, { Component } from "react";
import PlaceholderWinsIllustration from "./../../assets/placeholders/weekly_wins_placeholder.svg";

class PlaceholderWins extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { tableType } = this.props;
    return (
      <div className="weekly-wins-placeholder">
        <img style={{ width: "145px" }} src={PlaceholderWinsIllustration} />
        {tableType === "subAction" ? (
          <div className="subheader mt20">
            No subactions have been to this action. Add subactions by clicking
            on the button above
          </div>
        ) : (
          <div className="subheader mt20">
            You have not planned any Actions yet. <br />
            You can create an Action by typing in the text box above, or by
            using the list of Actions suggested by our experts, on the right.
          </div>
        )}
      </div>
    );
  }
}

export default PlaceholderWins;
